var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_vm._t("default"),(_vm.text)?_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }